import { useQuery } from "@tanstack/react-query";

import { CustomModelPricesResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { jsonAuthHeaders } from "@/utils/headers";

const EMPTY_RESPONSE: CustomModelPricesResponse = { success: true, custom_model_prices: [] };

export const useCustomModelPrices = (authToken: string, workspaceId: string | undefined) =>
  useQuery<CustomModelPricesResponse>({
    queryKey: ["customModelPrices", workspaceId],
    enabled: Boolean(workspaceId),
    queryFn: async () => {
      const response = await fetch(ENDPOINTS.custom_model_prices.list(String(workspaceId)), {
        headers: jsonAuthHeaders(authToken),
        method: "GET",
      });
      if (!response.ok) {
        return EMPTY_RESPONSE;
      }
      return response.json();
    },
  });
